import { replica } from '@/shared/sync/replica';
import { sessionStore } from '../lib/session-store';
import { storedSessionSchema } from '../schemas/stored-session';

const EVERY_MS = 10 * 60_000;
let lastRefresh = 0;

/** Pick up renamed or new people from the server (best effort, at most every 10 minutes). */
export async function refreshProfile(): Promise<void> {
  const session = sessionStore.read();
  if (!session || session.expired || Date.now() - lastRefresh < EVERY_MS) return;
  lastRefresh = Date.now();
  const me = storedSessionSchema.parse(await replica.http.json<unknown>('/me'));
  sessionStore.write({ ...me, expired: false });
}
